import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import axios from 'axios';

class Question5 extends Component {
	constructor(props) {
		super(props);
		this.state = {
      val: '',
		};

    this.sendFeedback = this.sendFeedback.bind(this);
    this.change = this.change.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);

	}

	render() {

    return(
      <div className="feedback-question">
				<h2>{this.props.t('Question5-Wat vind je niet goed aan Framefit?')}</h2>
        <p>{this.props.t('Question5-Wij vinden het jammer dat jouw ervaring met Framefit niet optimaal is')}.</p>
        <p>{this.props.t('Question5-Wil je ons vertellen wat wij kunnen verbeteren om wel aan jouw verwachtingen te voldoen?')}</p>
        <div className="input-container row">
          <div className="col">
            <textarea className="input" type="text" value={this.state.val} placeholder="..." onChange={this.change}></textarea>
          </div>
        </div>
        <div className="button-container row">
          <div className="col">
            <button className="btn btn-default" onClick={() => {this.closeFeedback()}}>{this.props.t('Question5-Sla over')}</button>
          </div>

          <div className="col">
            <button className="btn btn-primary col" onClick={() => {this.sendFeedback()}}>{this.props.t('Question5-Verstuur')}</button>
          </div>
        </div>
      </div>
    )


	}

  change = function (event) {
    let value = event.target.value;
    this.setState({val : value});
  }

  sendFeedback = function () {
    let reason = this.state.val;
		let sessionId = localStorage.getItem('sessionId');
    let url = "/feedback/negative-reason";
		let data = {
			'session_id' : sessionId,
			'reason' : reason
		};
    axios.post(url, data).then(response => {
      this.props.nextQuestion(5);
		}).catch(response => {
      console.log('error');
		})
  }

	closeFeedback = function () {
		this.props.nextQuestion(5);
	}


}

export default withTranslation('result')(Question5);
